import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { BusinessAreas } from './components/BusinessAreas';
import { AboutSection } from './components/AboutSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-white text-gray-900 font-sans" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <BusinessAreas data-id="element-4" />
        <AboutSection data-id="element-5" />
      </main>
      <Footer data-id="element-6" />
    </div>;
}